/* eslint-disable no-unused-vars */
import React from 'react';
import Box from '@material-ui/core/Box';
import ReactPlayer from 'react-player';

export const Video = ({
  url = '',
  onPlay = null,
  onPause = null,
  onEnded = null,
  height,
  isDesktop,
}) => {
  if (!url) {
    return null;
  }

  return (
    <Box height={height || (isDesktop ? 'calc(95vh - 80px)' : '210px')}>
      <ReactPlayer
        url={url}
        width="100%"
        height="100%"
        onPlay={onPlay}
        onPause={onPause}
        onEnded={onEnded}
      />
    </Box>
  );
};
